export const queryKeys = {
  PAYMENT_FIELD: 'PAYMENT_FIELD'
};
